import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const downloadOnlineSalesExcel = (data, fromdate, todate) => {
  const formattedFromDate = fromdate
    ? new Date(fromdate).toLocaleDateString()
    : "N/A";
  const formattedToDate = todate
    ? new Date(todate).toLocaleDateString()
    : "N/A";

  // Process data for Excel
  const processedData = data.map((item, index) => {
    const products = item.products || [];
    const totalQty = products.reduce((sum, p) => sum + parseInt(p.qty || 0), 0);

    // ✅ Status mapping
    let statusText = "Waiting for confirmation";
    switch (item.status) {
      case 1:
        statusText = "Confirmed";
        break;
      case 2:
        statusText = "Packing";
        break;
      case 3:
        statusText = "Delivered";
        break;
      case 4:
        statusText = "Rejected";
        break;
      default:
        statusText = "Waiting for confirmation";
    }

    return {
      "S No": index + 1,
      "Enquiry No": item.enquiry_no || "N/A",
      "Tax Invoice No": item.tax_invoice_no || "N/A",
      "Customer Name": item.customer_name || "N/A",
      Phone: item.phone || "N/A",
      // Products: products.map((p) => p.product_name).join(", ") || "N/A",
      Quantity: totalQty,
      Total: parseFloat(item.discount_total || 0).toFixed(2),
      "Order Status": statusText, // ✅ new column
    };
  });

  // Calculate total
  const subTotal = data.reduce(
    (acc, item) => acc + parseFloat(item.discount_total || 0),
    0
  );

  // Add summary row
  processedData.push({
    "S No": "Total",
    "Enquiry No": "",
    // "Tax Invoice  No": "",
    "Customer Name": "",
    Phone: "",
    // Products: "",
    Quantity: "",
    Total: subTotal.toFixed(2),
    "Order Status": "", // ✅ empty for summary row
  });

  // Create workbook and worksheet
  const worksheet = XLSX.utils.json_to_sheet(processedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Online Sales Report");

  // Add metadata
  XLSX.utils.sheet_add_aoa(
    worksheet,
    [[`Online Sales Report: ${formattedFromDate} to ${formattedToDate}`], []],
    { origin: "A1" }
  );

  // Adjust column widths
  const colWidths = [
    { wpx: 50 }, // S No
    { wpx: 120 }, // Enquiry No
    { wpx: 150 }, // Customer Name
    { wpx: 120 }, // Phone
    { wpx: 200 }, // Products
    { wpx: 80 }, // Quantity
    { wpx: 100 }, // Total
    { wpx: 150 }, // Order Status ✅
  ];
  worksheet["!cols"] = colWidths;

  // Convert to Excel file and trigger download
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(
    blob,
    `OnlineSalesReport_${formattedFromDate}_to_${formattedToDate}.xlsx`
  );
};
